export enum Sender {
	USER = 'user',
	API = 'api',
}
